import initGsapHero from "../timelines/gsapHero";
import initGsapSteps from "../timelines/gsapSteps";

export default function initGsapTimelines() {
    initGsapHero();
    initGsapSteps();
}
